import { CAMPAIGN_TYPE_ID } from '@enums';
import { useStore } from '@hooks';
import { Icon } from '@ui';
import { useSpecificCollection } from './useSpecificCollection';
import { useSpecificProductType } from './useSpecificProductType';
import { useTypeAvailability } from './useTypeAvailability';

const useCampaignTypes = () => {
    const specificProductTypes = useSpecificProductType();
    const specificCollections = useSpecificCollection();
    const unavailableReason = useTypeAvailability();

    const store = useStore();
    const { isBigCommerce, isManual } = store.accountsStore;

    const campaigns = {
        aiRecommended: {
            label: 'AI recommended',
            value: CAMPAIGN_TYPE_ID.AI_RECOMMENDED,
            description: 'Allow AI to automatically select your campaign type.',
            CardIcon: Icon.AiIcon
        },
        entireCatalog: {
            label: 'My Entire Catalog',
            value: CAMPAIGN_TYPE_ID.MY_ENTIRE_CATALOG,
            description: 'Allow Klickly to advertise all of your available products.',
            CardIcon: Icon.EntireCatalogIcon
        },
        specificProducts: {
            label: 'Specific Products',
            value: CAMPAIGN_TYPE_ID.SPECIFIC_PRODUCTS,
            description: 'Allow Klickly to advertise using 1 or more specific products.',
            CardIcon: Icon.SpecificProductsIcon
        }
    };

    // Types below stay in the grid even with no data - they render as disabled
    // blocks with a tooltip explaining why (KLIC-11364).
    campaigns.specificCollections = {
        ...specificCollections,
        unavailableReason: unavailableReason.specificCollections
    };

    campaigns.specificProductTypes = {
        ...specificProductTypes,
        unavailableReason: unavailableReason.specificProductTypes
    };

    campaigns.bestSellers = {
        label: 'My Best-sellers',
        value: CAMPAIGN_TYPE_ID.BEST_SELLERS,
        description: 'Allow Klickly to advertise your best sellers.',
        CardIcon: Icon.BestsellersSmallIcon,
        unavailableReason: unavailableReason.bestSellers
    };

    if (isBigCommerce || isManual) {
        delete campaigns.specificCollections;
        delete campaigns.specificProductTypes;
    }

    return campaigns;
};

export { useCampaignTypes };
